import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { NavLink, Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { FaSun, FaMoon } from 'react-icons/fa';

import './styles.css';

const FixedHeader = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Navbar
      variant={theme} // Set variant dynamically
      expand="lg"
      fixed="top"
      className="customFixedNavBar"
    >
      <Container fluid>
        <Navbar.Brand className="navbar-logo" as={Link} to="/">
          <img
            alt="ForFunLab"
            src="./../ForFunLab_logo.png"
            width="60"
            height="60"
            className="d-inline-block align-top"
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="w-100 justify-content-start justify-content-lg-end align-items-center">
            <NavLink
              className={({ isActive }) =>
                isActive
                  ? 'header-item nav-pill mx-4 active'
                  : 'header-item nav-pill mx-4'
              }
              to="/lab-ninjas"
            >
              Lab Ninjas
            </NavLink>
            <NavLink
              className={({ isActive }) =>
                isActive
                  ? 'header-item nav-pill mx-4 active'
                  : 'header-item nav-pill mx-4'
              }
              to="/football-predictor"
            >
              Football Predictor
            </NavLink>

            <button
              onClick={toggleTheme}
              className={`theme-toggle-switch ms-3 ${theme}`}
              aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
            >
              <div className="theme-toggle-thumb">
                {theme === 'dark' ? <FaMoon /> : <FaSun />}
              </div>
            </button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default FixedHeader;
